import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-text-center h-mb-20" }
const _hoisted_2 = { class: "b-base-title h-mt-10" }
const _hoisted_3 = { class: "h-pos-rel" }
const _hoisted_4 = { class: "b-text-error h-text-center h-fw-500" }
const _hoisted_5 = { class: "h-flex h-flex-center h-flex-dir-column h-width-100p" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "h-mb-10 h-pointer h-fw-500 h-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GoogleSignIn = _resolveComponent("GoogleSignIn")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('AUTH.LOGIN.TITLE')), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        class: "h-mt-15",
        onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendDataToServer && _ctx.sendDataToServer(...args)), ["enter"]))
      }, [
        _createVNode(_component_FwFormInput, {
          class: "h-mb-25 qa-user-email-input",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.email, _ctx.EMAIL, _ctx.emailRules),
          labelType: "label-thin",
          title: _ctx.$t(`AUTH.SIGN_UP.FORM.EMAIL.LABEL`)
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_FwInput, {
              value: _ctx.email,
              type: "text",
              name: "text",
              inputStyle: "gray",
              placeholder: "adresse@email.com",
              error: _ctx.getFieldErrorTextByRule(_ctx.email, _ctx.EMAIL, _ctx.emailRules),
              onUpdate: _cache[0] || (_cache[0] = value => _ctx.email = value),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.EMAIL))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.EMAIL)))
            }, null, 8, ["value", "error"]), [
              [_directive_focus, true]
            ])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: "ForgotPasswordPopup" },
            class: "b-login-form-forgot-password"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`AUTH.LOGIN.FORM.FORGET.PASSWORD`)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_FwFormInput, {
            class: "h-mb-25 qa-user-password-input",
            fieldHasError: _ctx.fieldHasErrorByRule(_ctx.password, _ctx.PASSWORD, _ctx.passwordRules),
            labelType: "label-thin",
            title: _ctx.$t(`AUTH.LOGIN.FORM.PASSWORD.LABEL`)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FwInput, {
                value: _ctx.password,
                type: "password",
                name: "password",
                placeholder: _ctx.$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`),
                inputStyle: "gray",
                error: _ctx.getFieldErrorTextByRule(_ctx.password, _ctx.PASSWORD, _ctx.passwordRules),
                onUpdate: _cache[3] || (_cache[3] = value => _ctx.password = value),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearServerErrorsBase(_ctx.PASSWORD))),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addCurrentInputToValidateArray(_ctx.PASSWORD)))
              }, null, 8, ["value", "placeholder", "error"])
            ]),
            _: 1
          }, 8, ["fieldHasError", "title"])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.globalServerError), 1),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isHesAccount)
        ? (_openBlock(), _createBlock(_component_GoogleSignIn, {
            key: 0,
            account: _ctx.companyName.toLowerCase()
          }, null, 8, ["account"]))
        : _createCommentVNode("", true),
      (_ctx.isSsoShown)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "b-login-sso--button",
            href: _ctx.accountSsoUrl
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('LOGIN.WITH.SSO')), 1)
          ], 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createVNode(_component_FwButton, {
        class: "h-mt-10 qa-base-login-submit",
        disabled: !_ctx.isFormValid || _ctx.isRequestSend,
        borderRadiusType: "small-border",
        onClick: _ctx.sendDataToServer
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('AUTH.LOGIN.FORM.BUTTON.NEXT')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_router_link, {
      to: { name: "ConfirmMyAccount" },
      class: "b-url-with-arrow h-mt-20"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('AUTH.CONFIRM_ACCOUNT.LINK_TEXT')) + " ", 1),
        _createVNode(_component_FwIcon, {
          class: "h-ml-15 b-url-with-arrow__icon",
          icon: "arrow-right",
          size: "10",
          color: "#BEC7D3"
        })
      ]),
      _: 1
    })
  ]))
}